import { useTranslation } from 'react-i18next'
import { Button } from '../Button/Button'
import { cx } from '../utils/cx'
import type { AmountCardProps } from './types'
import './AmountCard.css'

/** Tarjeta de importe (DESIGN.md §4): total en display, filas de 44 px, separador y botón de pago. También "Tarjeta de diferencia de precio". */
export function AmountCard({ total, totalLabel, totalRowLabel, chip, lines = [], buttonLabel, onPay, loading, note, children, className }: AmountCardProps) {
  const { t } = useTranslation()
  const label = totalLabel ?? t('v2.ds.amountCard.total')
  const button = buttonLabel === undefined ? t('v2.ds.amountCard.pagarAhora') : buttonLabel
  return (
    <div className={cx('hp-amount', className)}>
      <div className={cx('hp-amount__head', chip !== undefined && 'hp-amount__head--chip')}>
        <div>
          <div className="hp-amount__label">{label}</div>
          <div className="hp-amount__total tnum">{total}</div>
        </div>
        {chip && <div className="hp-amount__chip">{chip}</div>}
      </div>
      {lines.length > 0 && (
        <dl className="hp-amount__lines">
          {lines.map((l, i) => (
            <div key={i} className={cx('hp-amount__line', l.tone && `hp-amount__line--${l.tone}`)}>
              <dt>{l.label}</dt>
              <dd className="tnum">{l.amount}</dd>
            </div>
          ))}
          <div className="hp-amount__line hp-amount__line--total">
            <dt>{totalRowLabel ?? label}</dt>
            <dd className="tnum">{total}</dd>
          </div>
        </dl>
      )}
      {note && <p className="hp-amount__note">{note}</p>}
      {children}
      {button && (
        <Button variant="primary" onClick={onPay} loading={loading ?? false}>
          {button}
        </Button>
      )}
    </div>
  )
}
